import { api } from './client';
import type { Page } from './catalogs';

/** Сервісні запити до ДПС (Кабінет ДПС → «створити»). */

export interface DpsRequestForm {
  code: string;    // J-код (юрособи)
  f_code: string;  // F-код (ФОП)
  title: string;
}

export interface DpsRequest {
  id: string;
  organization_id: string;
  form_code: string;
  document_number: string;
  document_date: string;
  period_month: number;
  period_year: number;
  period_end_date: string | null;
  sti_name: string | null;
  receive_mode: string;
  deletion_mark: boolean;
  comment: string | null;
  created_at: string;
}

export interface DpsRequestCreate {
  organization_id: string;
  form_code: string;
  document_date: string;
  period_month: number;
  period_year: number;
  period_end_date?: string | null;
  sti_name?: string | null;
  receive_mode?: 'M01' | 'M02' | 'M03' | 'M04' | 'M05';
  comment?: string | null;
}

export const dpsRequests = {
  forms: () => api.get<DpsRequestForm[]>('/dps-requests/forms').then((r) => r.data),
  list: (params?: { organization_id?: string; limit?: number }) =>
    api.get<Page<DpsRequest>>('/dps-requests', { params }).then((r) => r.data),
  get: (id: string) => api.get<DpsRequest>(`/dps-requests/${id}`).then((r) => r.data),
  create: (p: DpsRequestCreate) =>
    api.post<DpsRequest>('/dps-requests', p).then((r) => r.data),
  remove: (id: string) => api.delete(`/dps-requests/${id}`).then(() => undefined),
  xml: (id: string) => api.get(`/dps-requests/${id}/xml`, { responseType: 'blob' }),
};
